var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import toast from 'react-hot-toast';
import { RollupType, TagType, } from '@common/api';
import { farseerFilesApi, importJobsApi, tagRelationsApi, tagsApi } from '@data/rest/api';
import { TagQueryKeys } from '@data/tag/types';
import { globalLoadingWrapped } from './util';
export function uploadAndImportFile(file, replaceImportJobId, L) {
    return __awaiter(this, void 0, Promise, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, globalLoadingWrapped(function () { return __awaiter(_this, void 0, void 0, function () {
                        var farseerFile, createdImportJobs, err_1, errBody;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 5, , 9]);
                                    return [4 /*yield*/, farseerFilesApi.create(file, 'IMPORT_FILE')];
                                case 1:
                                    farseerFile = _a.sent();
                                    return [4 /*yield*/, importJobsApi.importFarseerFile({
                                            farseerFileId: farseerFile.id,
                                            title: farseerFile.name,
                                        })];
                                case 2:
                                    createdImportJobs = _a.sent();
                                    if (!(replaceImportJobId !== null)) return [3 /*break*/, 4];
                                    return [4 /*yield*/, importJobsApi.remove(replaceImportJobId)];
                                case 3:
                                    _a.sent();
                                    _a.label = 4;
                                case 4: return [2 /*return*/, createdImportJobs];
                                case 5:
                                    err_1 = _a.sent();
                                    if (!(err_1 instanceof Response)) return [3 /*break*/, 7];
                                    return [4 /*yield*/, err_1.json()];
                                case 6:
                                    errBody = _a.sent();
                                    if ('message' in errBody) {
                                        toast.error(errBody.message);
                                    }
                                    else {
                                        toast.error(JSON.stringify(errBody));
                                    }
                                    return [3 /*break*/, 8];
                                case 7:
                                    toast.error(L('Error when importing file'));
                                    _a.label = 8;
                                case 8: return [3 /*break*/, 9];
                                case 9: return [2 /*return*/];
                            }
                        });
                    }); })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function addMissingTags(importJobId, queryClient, tableTagRelations, createInfo) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var newTags, lowerCaseTagNameSet, connectedTagIdsByTagName, connectedIdsByParent, relationIdByConnectedId, j, tagName, lowerCaseTagName, desc, parentId, newTag, connectedTagsForItem, connectedTagsForItem_1, connectedTagsForItem_1_1, connectedTag, connectedTagIds, _loop_1, _c, _d, connectedTableTagId, e_1_1, tags, _loop_2, _e, _f, _g, parentId, connectIds, state_1, e_2_1, err_2;
        var e_3, _h, e_1, _j, e_2, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    _l.trys.push([0, 20, , 21]);
                    newTags = [];
                    if (createInfo.column === undefined) {
                        return [2 /*return*/];
                    }
                    lowerCaseTagNameSet = new Set();
                    connectedTagIdsByTagName = new Map();
                    connectedIdsByParent = new Map();
                    relationIdByConnectedId = new Map();
                    for (j = 0; j < createInfo.column.tagNames.length; j++) {
                        if (!createInfo.selected[j]) {
                            continue;
                        }
                        tagName = '' + createInfo.column.tagNames[j];
                        lowerCaseTagName = tagName.toLowerCase();
                        if (lowerCaseTagNameSet.has(lowerCaseTagName)) {
                            // skip creating same tag with name in different case
                            continue;
                        }
                        else {
                            lowerCaseTagNameSet.add(lowerCaseTagName);
                        }
                        desc = (_a = createInfo.descriptions[j]) !== null && _a !== void 0 ? _a : '';
                        parentId = createInfo.column.tableTagId;
                        newTag = {
                            name: tagName,
                            type: TagType.Dimension,
                            rollupType: RollupType.Sum,
                            ParentId: parentId,
                            description: desc,
                            jsonData: null,
                            connectedTagIds: [],
                            order: 0,
                        };
                        connectedTagsForItem = createInfo.connectedTags[j];
                        if (connectedTagsForItem !== undefined) {
                            try {
                                for (connectedTagsForItem_1 = (e_3 = void 0, __values(connectedTagsForItem)), connectedTagsForItem_1_1 = connectedTagsForItem_1.next(); !connectedTagsForItem_1_1.done; connectedTagsForItem_1_1 = connectedTagsForItem_1.next()) {
                                    connectedTag = connectedTagsForItem_1_1.value;
                                    if (connectedTag.ParentId !== null) {
                                        newTag.connectedTagIds.push(connectedTag.id);
                                        connectedTagIds = (_b = connectedIdsByParent.get(connectedTag.ParentId)) !== null && _b !== void 0 ? _b : new Set();
                                        connectedTagIds.add(connectedTag.id);
                                        connectedIdsByParent.set(connectedTag.ParentId, connectedTagIds);
                                    }
                                }
                            }
                            catch (e_3_1) { e_3 = { error: e_3_1 }; }
                            finally {
                                try {
                                    if (connectedTagsForItem_1_1 && !connectedTagsForItem_1_1.done && (_h = connectedTagsForItem_1.return)) _h.call(connectedTagsForItem_1);
                                }
                                finally { if (e_3) throw e_3.error; }
                            }
                        }
                        connectedTagIdsByTagName.set(lowerCaseTagName, newTag.connectedTagIds);
                        newTags.push(newTag);
                    }
                    _loop_1 = function (connectedTableTagId) {
                        var relation, error_1, relation;
                        return __generator(this, function (_m) {
                            switch (_m.label) {
                                case 0:
                                    _m.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, tagRelationsApi.create({
                                            tableTagId: createInfo.column.tableTagId,
                                            connectedTableTagId: connectedTableTagId,
                                            name: '' + createInfo.column.tableTagId + '-' + connectedTableTagId,
                                            description: 'Connection created by import job id=' + importJobId,
                                        })];
                                case 1:
                                    relation = _m.sent();
                                    relationIdByConnectedId.set(connectedTableTagId, relation.id);
                                    return [3 /*break*/, 3];
                                case 2:
                                    error_1 = _m.sent();
                                    relation = tableTagRelations.find(function (r) { return r.connectedTableTagId === connectedTableTagId; });
                                    if (relation !== undefined) {
                                        relationIdByConnectedId.set(connectedTableTagId, relation.id);
                                    }
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    };
                    _l.label = 1;
                case 1:
                    _l.trys.push([1, 6, 7, 8]);
                    _c = __values(connectedIdsByParent.keys()), _d = _c.next();
                    _l.label = 2;
                case 2:
                    if (!!_d.done) return [3 /*break*/, 5];
                    connectedTableTagId = _d.value;
                    return [5 /*yield**/, _loop_1(connectedTableTagId)];
                case 3:
                    _l.sent();
                    _l.label = 4;
                case 4:
                    _d = _c.next();
                    return [3 /*break*/, 2];
                case 5: return [3 /*break*/, 8];
                case 6:
                    e_1_1 = _l.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 8];
                case 7:
                    try {
                        if (_d && !_d.done && (_j = _c.return)) _j.call(_c);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 8: return [4 /*yield*/, tagsApi.createBatch(newTags)];
                case 9:
                    tags = _l.sent();
                    _loop_2 = function (parentId, connectIds) {
                        var relationId, connections, _loop_3, tags_1, tags_1_1, tag;
                        var e_4, _o;
                        return __generator(this, function (_p) {
                            switch (_p.label) {
                                case 0:
                                    relationId = relationIdByConnectedId.get(parentId);
                                    connections = [];
                                    if (!relationId) {
                                        return [2 /*return*/, { value: void 0 }];
                                    }
                                    _loop_3 = function (tag) {
                                        var connectedTagIds = connectedTagIdsByTagName.get(tag.name.toLowerCase());
                                        if (connectedTagIds === null || connectedTagIds === void 0 ? void 0 : connectedTagIds.length) {
                                            var con = connectedTagIds
                                                .filter(function (tid) { return connectIds.has(tid); })
                                                .map(function (id) { return ({
                                                connectedDimensionTagId: id,
                                                dimensionTagId: tag.id,
                                            }); });
                                            connections.push.apply(connections, __spreadArray([], __read(con), false));
                                        }
                                    };
                                    try {
                                        for (tags_1 = (e_4 = void 0, __values(tags)), tags_1_1 = tags_1.next(); !tags_1_1.done; tags_1_1 = tags_1.next()) {
                                            tag = tags_1_1.value;
                                            _loop_3(tag);
                                        }
                                    }
                                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                                    finally {
                                        try {
                                            if (tags_1_1 && !tags_1_1.done && (_o = tags_1.return)) _o.call(tags_1);
                                        }
                                        finally { if (e_4) throw e_4.error; }
                                    }
                                    return [4 /*yield*/, tagRelationsApi.addConnections(relationId, {
                                            connections: connections,
                                        })];
                                case 1:
                                    _p.sent();
                                    return [2 /*return*/];
                            }
                        });
                    };
                    _l.label = 10;
                case 10:
                    _l.trys.push([10, 15, 16, 17]);
                    _e = __values(connectedIdsByParent.entries()), _f = _e.next();
                    _l.label = 11;
                case 11:
                    if (!!_f.done) return [3 /*break*/, 14];
                    _g = __read(_f.value, 2), parentId = _g[0], connectIds = _g[1];
                    return [5 /*yield**/, _loop_2(parentId, connectIds)];
                case 12:
                    state_1 = _l.sent();
                    if (typeof state_1 === "object")
                        return [2 /*return*/, state_1.value];
                    _l.label = 13;
                case 13:
                    _f = _e.next();
                    return [3 /*break*/, 11];
                case 14: return [3 /*break*/, 17];
                case 15:
                    e_2_1 = _l.sent();
                    e_2 = { error: e_2_1 };
                    return [3 /*break*/, 17];
                case 16:
                    try {
                        if (_f && !_f.done && (_k = _e.return)) _k.call(_e);
                    }
                    finally { if (e_2) throw e_2.error; }
                    return [7 /*endfinally*/];
                case 17: return [4 /*yield*/, queryClient.invalidateQueries(TagQueryKeys.Tags)];
                case 18:
                    _l.sent();
                    return [4 /*yield*/, queryClient.invalidateQueries(TagQueryKeys.Relations)];
                case 19:
                    _l.sent();
                    return [3 /*break*/, 21];
                case 20:
                    err_2 = _l.sent();
                    toast.error('Error add tags', err_2.message);
                    return [3 /*break*/, 21];
                case 21: return [2 /*return*/];
            }
        });
    });
}
